import type { Workspace, WorkspaceDataSummaryResponse } from '@/lib/api';

const ACRONYMS: Record<string, string> = { crm: 'CRM', ai: 'AI', api: 'API', payu: 'PayU' };

export function humanizeTableName(name: string): string {
  return name
    .split('_')
    .filter(Boolean)
    .map((word) => ACRONYMS[word.toLowerCase()] || word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function canOfferDeleteWorkspace(workspace: Workspace, totalWorkspaceCount: number): boolean {
  return !workspace.is_default && totalWorkspaceCount > 1;
}

export function canOfferSetDefaultWorkspace(workspace: Workspace): boolean {
  return !workspace.is_default;
}

export function canConnectWhatsAppToWorkspace(workspace: Workspace | null | undefined): boolean {
  if (!workspace) return false;
  return !workspace.business_account_id && !workspace.whatsapp;
}

export function applyWorkspaceUpdateToList(list: Workspace[], updated: Workspace): Workspace[] {
  return list.map((w) => {
    if (w.id === updated.id) return { ...w, ...updated };
    if (updated.is_default && w.is_default) return { ...w, is_default: false };
    return w;
  });
}

export function removeWorkspaceFromList(list: Workspace[], deletedId: string): Workspace[] {
  return list.filter((w) => w.id !== deletedId);
}

export function sumMovedCounts(moved: Record<string, number> | null | undefined): number {
  if (!moved) return 0;
  return Object.values(moved).reduce((sum, n) => sum + (Number.isFinite(n) ? n : 0), 0);
}

export function isMoveRequiredError(err: unknown): boolean {
  const e = err as { statusCode?: number; meta?: { data_summary?: unknown } } | null | undefined;
  return e?.statusCode === 409 && !!e?.meta?.data_summary;
}

export function canSubmitWorkspaceDelete({
  summary,
  targetId,
  isPending,
}: {
  summary: WorkspaceDataSummaryResponse | null | undefined;
  targetId: string;
  isPending: boolean;
}): boolean {
  if (!summary || isPending) return false;
  if (summary.businessAccount) return false;
  if (summary.hasAnyData) return !!targetId;
  return true;
}
